<template>
  <div class="NumChangePicker">
    <el-dialog
      :visible.sync="showNumDialog"
      center
      :show-close="false"
      :before-close="beforeClose"
      custom-class="picker-modal"
    >
      <div class="header clearfix">
        <div class="numTitle fl">
          {{ ('购物车内的','my') }} <strong>{{ goodsList.length <= 99 ? goodsList.length : '99+' }}</strong> {{ TLang('个商品发生了变化','my') }}
        </div>
        <i class="icon iconfont fr" @click="beforeClose">&#xe65d;</i>
      </div>
      <div class="modal-wrap">
        <div class="main-content">
          <div>
            <div class="numChangeWrap">
              <ul v-if="goodsList && goodsList.length > 0">
                <li v-for="(item, index) in goodsList" :key="index">
                  <div class="goodsInfo clearfix">
                    <div class="goodsImgInfo fl">
                      <img class="goodsImg" :src="item.pcPicUrl" alt="" />
                    </div>
                    <div class="goodsTitle fl">{{ item.goodsName }}</div>
                    <div class="changeInfo fl">
                      <!-- 101起购 102限购 201库存不足 -->
                      <span v-if="item.goodsNumChangeType == 101">
                        {{ TLang('起购数量从x变y1','my') }} <strong>{{ item.oldNum }}</strong> {{ TLang('起购数量从x变y2','my') }} <strong>{{ item.newNum }}</strong> {{ TLang('起购数量从x变y3','my') }}
                      </span>
                      <span v-if="item.goodsNumChangeType == 102">
                        {{ TLang('限购数量从x变y1','my') }} <strong>{{ item.oldNum }}</strong> {{ TLang('限购数量从x变y2','my') }} <strong>{{ item.newNum }}</strong> {{ TLang('限购数量从x变y3','my') }}
                      </span>
                      <span v-if="item.goodsNumChangeType == 201">
                        {{ TLang('购买数量从x变y1','my') }} <strong>{{ item.oldNum }}</strong> {{ TLang('购买数量从x变y2','my') }} <strong>{{ item.newNum }}</strong>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="btnWrap">
              <el-button type="primary" @click="callback()">{{ TLang('我知道了','my') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "NumChangeDialog",
  props: {
    showNumDialog: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    goodsList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {};
  },
  methods: {
    callback() {
      this.$emit("callback");
    },
    beforeClose() {
      this.callback();
    },
  },
};
</script>

<style lang="less">
.NumChangePicker {
  .picker-modal {
    margin-top: 50vh !important;
    transform: translateY(-50%);
    width: 720px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .header {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    height: 76px;
    line-height: 76px;
    border-bottom: 1px solid #E5E5E5;
    .numTitle {
      font-size: 18px;
    
      color: #111;
    }
    i {
      font-size: 30px;
      color: #333;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .modal-wrap {
    .main-content {
      .numChangeWrap {
        height: auto;
        min-height: 300px;
        max-height: 300px;
        overflow-y: scroll;
        padding: 24px;
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        border-bottom: 1px solid #E5E5E5;
        li {
          margin-bottom: 16px;
          .goodsInfo {
            .goodsImgInfo{
              width: 90px;
              height: 90px;
              margin-right: 12px;
              overflow: hidden;
              .goodsImg {
                width: 90px;
                height: auto;
                min-height: 90px;
                display: block;
              }
            }
            .goodsTitle {
              width: 560px;
              height: 18px;
              font-size: 14px;
              color: #111;
              line-height: 18px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              margin-bottom: 16px;
            }
          }
          .changeInfo {
            height: 16px;
            font-size: 12px;
            color: #F75E35;
            line-height: 16px;
          }
        }
      }
      .btnWrap {
        width: 720px;
        height: 72px;
        background: #fff;
        box-sizing: border-box;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
        border-radius: 0px 0px 4px 4px;
        padding: 16px 24px;
        text-align: right;
        button {
          background: linear-gradient(315deg, #5CB4EC 0%, #3D96E2 100%);
          border: none;
          border-radius: 4px;
        }
      }
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clearfix {
  *zoom: 1;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
</style>
